import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideToast } from "../redux/slices/ToastSlice";

const Toast = () => {
  const dispatch = useDispatch();
  const { isVisible, message, type } = useSelector(
    (state) => state.toastMessage
  );
  console.log('message',message,'type',type,'isVisible',isVisible)
  useEffect(() => {
    if (isVisible) {
      // Automatically hide toast after 3 seconds
      const timer = setTimeout(() => {
        dispatch(hideToast());
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isVisible, dispatch]);

  if (!isVisible) return null;

  return (
    <div
      style={{ zIndex: "100" }}
      className={`custom-toast ${
        type === "error" ? "custom-toast-error" : ""
      }`}
    >
      <div className="show toast-message ml-2 mr-2">{message}</div>
    </div>
  );
};

export default Toast;
